'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { HiddenCheckbox, Label, SwitchElement } from './switchElements';
export const Switch = /*#__PURE__*/React.forwardRef(({
  label,
  labelPosition = 'left',
  className,
  size = 'default',
  ...rest
}, fRef) => /*#__PURE__*/React.createElement(Label, {
  "data-aui": "switch",
  $labelPosition: labelPosition,
  className: className
}, label, /*#__PURE__*/React.createElement(HiddenCheckbox, _extends({
  type: "checkbox",
  ref: fRef
}, rest)), /*#__PURE__*/React.createElement(SwitchElement, {
  $size: size,
  $checked: rest.checked,
  $disabled: rest.disabled
})));